<template>
  <div>
    <div class="header">
      <h4>Rules</h4>
      <div class="buttons">
        <el-button
          type="primary"
          @click="newItem"
          size="mini"
          icon="el-icon-plus"
          round
          >New</el-button
        >
      </div>
    </div>
    <Table
      :items="hubspotRules"
      :columns="columns"
      :actions="actions"
      filterProp="event_action"
      :loading="loading.hubspotRules"
    />

    <EditDialog
      :item="item"
      :isOpen="showEditDialog"
      :onClose="onCloseDialog"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Table from "@/components/Table";
import EditDialog from "./HubspotRulesDialog";
import { defaultHubspotRuleItem, hubspotRulesColumns } from "../constants";

export default {
  name: "hubspot",
  data() {
    return {
      columns: hubspotRulesColumns,
      actions: [
        { name: "Edit", type: "default", onClick: this.edit },
        { name: "Delete", type: "danger", onClick: this.delete },
      ],

      item: {},
      showEditDialog: false,
    };
  },
  mounted() {
    this.getHubspotRules();
    this.getEvents();
  },
  components: {
    Table,
    EditDialog,
  },
  computed: mapGetters(["hubspotRules", "loading"]),
  methods: {
    ...mapActions(["getHubspotRules", "getEvents"]),
    newItem() {
      this.item = Object.assign({}, defaultHubspotRuleItem);
      this.item.hubspot_properties_map = [];
      this.showEditDialog = true;
    },
    edit(hubspotItem) {
      this.item = Object.assign({}, hubspotItem);
      this.showEditDialog = true;
    },
    onCloseDialog() {
      this.showEditDialog = false;
    },
    async delete(hubspotItem) {
      await this.$api.delete(`/marketing/hubspot/rule/${hubspotItem.id}`);
      this.$message.info("Hubspot rule deleted successfully");
      this.getHubspotRules();
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.buttons > * {
  margin-right: 5px;
}

h4 {
  margin-right: 10px;
}
</style>
